module.exports = __webpack_public_path__ + "img/nolan-google-web-search.25246220.svg";